import {memo} from "react";
import {Checkbox, CheckboxProps} from "../../ui/checkbox";

export const SelectionCheckbox = memo((props: CheckboxProps) => {
  return (
    <Checkbox
      size="sm"
      colorPalette="blue"
      w="full"
      h="full"
      pl="8"
      display="flex"
      flexFlow="column"
      justifyContent="center"
      alignItems="flex-start"
      {...props}
    />
  );
});
